export default "__VITE_ASSET__9684ba26__"